import React, { useEffect, useState } from 'react'
import Autosuggest from 'react-autosuggest'
import Select from 'react-select'
import { connect } from 'react-redux';

import OurModal from '../../../components/ourModal'
import ToastMessage from '../../../components/toast'
import ReportDateRange from '../../../components/reportDateRange'
import { saveEmailSchedule, getEmailAddresses } from "../../../store/actions";
import {
    dateFrequency,
    numberedWeekDays,
    timeFrames as getTimeFrames
} from "../../../utils/constants";
import '../style.scss'

const AddSchedule = ({
    onClose,
    isEditSchedule,
    editScheduleData,
    reportsList,
    UserReducer
}) => {
    const [selectedReport, setSelectedReport] = useState('')
    const [scheduleStartDate, setScheduleStartDate] = useState(new Date())
    const [scheduleEndDate, setScheduleEndDate] = useState(null)
    const [isEmptyEndDate, setIsEmptyEndDate] = useState(true)
    const [endDateKey, setEndDateKey] = useState(Date.now())
    const [selectedFrequency, setSelectedFrequency] = useState(dateFrequency[0])
    const [selectedDaysOfWeek, setSelectedDaysOfWeek] = useState([])
    const [endDateErrMsg, setEndDateErrMsg] = useState(false)
    const [selectedDaysOfMonth, setSelectedDaysOfMonth] = useState([])
    const [onLastDayOfMonth, setOnLastDayOfMonth] = useState(false)
    const [selectedTime, setSelectedTime] = useState('')
    const [timeFrames, setTimeFrames] = useState([])
    const [showDayOrDateSelect, setShowDayOrDateSelect] = useState(false)
    const [quarterSelected, setQuarterSelected] = useState(false)
    const [filteredSuggestions, setFilteredSuggestions] = useState([])
    const [newEmailAddress, setNewEmailAddress] = useState('')
    const [invalidEmail, setInvalidEmail] = useState(false)
    const [emailsList, setEmailsList] = useState([])
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')
    const [fileName, setFileName] = useState('')
    const [fileFormat, setFileFormat] = useState('pdf')
    const [scheduleId, setScheduleId] = useState(null)
    const [suggestionList, setSuggestionList] = useState([])

    // Inital load
    useEffect(() => {
        populateTime();
        fetchSuggestions();
        if (isEditSchedule && editScheduleData) {
            console.log('editScheduleData', editScheduleData)
            let {
                _id,
                reportName,
                scheduleStartDate,
                scheduleEndDate,
                scheduleFrequency,
                scheduleDaysOfWeek,
                scheduleDaysOfMonth,
                onLastDayOfMonth,
                scheduleDeliveryTime,
                emailRecipients,
                subject,
                message,
                fileName,
                fileFormat,
            } = editScheduleData;
            let daysOfWeek = numberedWeekDays;
            setScheduleId(_id)
            setSelectedReport(reportName)
            setScheduleStartDate(new Date(scheduleStartDate))
            setScheduleEndDate(scheduleEndDate)
            setSelectedFrequency(scheduleFrequency)
            setSelectedDaysOfWeek(daysOfWeek.filter(nwd => scheduleDaysOfWeek.find(sdw => sdw === nwd.value)))
            setSelectedDaysOfMonth(scheduleDaysOfMonth)
            setOnLastDayOfMonth(onLastDayOfMonth)
            setSelectedTime(scheduleDeliveryTime)
            setEmailsList(emailRecipients)
            setSubject(subject)
            setMessage(message)
            setFileName(fileName)
            setFileFormat(fileFormat)
            if (scheduleEndDate) {
                setScheduleEndDate(new Date(scheduleEndDate))
                setIsEmptyEndDate(false)
                setEndDateKey(Date.now())
            }
        }
    }, [])

    // When frequency changes
    useEffect(() => {
        if (selectedFrequency === "Weekly" || selectedFrequency === "Monthly") {
            setQuarterSelected(false)
            setShowDayOrDateSelect(true)
        } else if (selectedFrequency === "Quarterly") {
            setShowDayOrDateSelect(false)
            setQuarterSelected(true)
        } else {
            setShowDayOrDateSelect(false)
            setQuarterSelected(false)
        }
    }, [selectedFrequency])

    const selectStyle = {
        control: (provided, state) => ({
            ...provided,
            fontSize: '14px',
            textWrap: 'nowrap',
            borderColor: state.isFocused ? '#47E5EB' : '#ccc',
            boxShadow: state.isFocused ? '0 0 0 1px #47E5EB' : null,
            '&:hover': {
                borderColor: state.isFocused ? '#47E5EB' : '#ccc'
            },
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: 'black',
            padding: '0px',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
            transition: 'transform 0.2s ease'
        }),
        clearIndicator: (provided) => ({
            ...provided,
            color: '#ccc',
            padding: '0px',
            cursor: 'pointer',
        }),
        input: (provided) => ({
            ...provided,
            margin: '0',
            padding: '0',
            color: '#333'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#999',
            fontSize: '14px'
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
            textWrap: 'nowrap',
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#333',
            width: '30px',
            height: '20px',
            fontSize: '12px',
            padding: '2px 6px'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            fontSize: '18px',
            width: '20px',
            height: '20px',
            color: '#666',
            '&:hover': {
                backgroundColor: '#ddd',
                color: '#333'
            }
        })
    }

    const handleEndApply = (date) => {
        if (date < scheduleStartDate) {
            setScheduleEndDate(null)
            setIsEmptyEndDate(true)
            setEndDateKey(Date.now())
            setEndDateErrMsg(true)
            setTimeout(() => {
                setEndDateErrMsg(false)
            }, 5000)
        } else {
            setEndDateErrMsg(false)
            setScheduleEndDate(date)
            setIsEmptyEndDate(false)
        }
    };

    const populateTime = () => {
        const timeFrames = getTimeFrames();
        setTimeFrames(timeFrames)
        setSelectedTime(timeFrames[0]?.value)
    };

    const fetchSuggestions = async () => {
        const companyId = UserReducer.companyId || UserReducer.companyDetails._id;
        const suggestions = await getEmailAddresses(companyId);
        setSuggestionList(suggestions);
    }

    const filterSuggestions = ({ value }) => {
        let filteredSuggestions = [];
        if (value && value.length > 0) {
            const inputValue = value.toLowerCase().trim()
            filteredSuggestions = suggestionList.filter(el =>
                el.toLowerCase().includes(inputValue)
                && !emailsList.includes(el))
        };
        setFilteredSuggestions(filteredSuggestions)
    };

    const clearSuggestions = () => {
        return filterSuggestions("");
    };

    const renderSuggestion = item => {
        return (<span>{item}</span>)
    };

    const selectSuggestion = value => {
        setNewEmailAddress(value);
        return value;
    }

    const isValidEmail = email => {
        //the regex validates that email body has only allowed characters, contains an @ sign, & domain / subdomains according to the rules.
        let valid = new RegExp(/^[\w!#$%&'*+\/=?`.{|}~^-]+(?:\.[\w!#$%&'*+\/=?`{|}~^-]+)*@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,6}$/);
        return valid.test(email);
    };

    const addEmailAddress = (e) => {
        e.preventDefault();
        setInvalidEmail(null)
        if (newEmailAddress && isValidEmail(newEmailAddress)) {
            if (!emailsList.includes(newEmailAddress)) {
                setEmailsList([...emailsList, newEmailAddress])
                setInvalidEmail(null)
            } else {
                setInvalidEmail("Email already added")
            }
            setNewEmailAddress('')
        } else {
            setInvalidEmail("That's not a valid Email. Try again...")
        }
    }

    const removeEmailAddress = (email) => {
        const updatedEmails = emailsList.filter(el => el !== email)
        setEmailsList(updatedEmails)
    }

    const handleEmailInput = (e, { newValue }) => {
        setNewEmailAddress(newValue)
    }

    const onSave = async (e) => {
        e.preventDefault();
        try {
            let payload = {
                companyId: UserReducer.companyId || UserReducer.companyDetails._id,
                reportName: selectedReport,
                scheduleStartDate: Number(scheduleStartDate),
                scheduleFrequency: selectedFrequency,
                scheduleDaysOfMonth: selectedDaysOfMonth,
                scheduleDaysOfWeek: selectedDaysOfWeek.map(sdw => sdw.value),
                scheduleDeliveryTime: selectedTime,
                onLastDayOfMonth,
                emailRecipients: emailsList,
                subject,
                message,
                fileName,
                fileFormat,
                createdBy: UserReducer.LOGIN_AS ? 'Admin' : UserReducer.username,
            };
            if (scheduleId) {
                payload._id = scheduleId;
            };
            if (!isEmptyEndDate) {
                payload.scheduleEndDate = Number(scheduleEndDate);
            } else {
                payload.scheduleEndDate = null;
            };
            await saveEmailSchedule(payload);
            ToastMessage(isEditSchedule ? "Schedule updated successfully" : "Schedule created successfully", "success");
            onClose(true);
        } catch (error) {
            ToastMessage(error.message || "Failed to save schedule", "error");
        }
    }

    const generateFileName = () => {
        const fileName = `My ${selectedReport ? reportsList.find(el => el.key === selectedReport)?.label : ''} Report`
        let i = 0;
        const interval = setInterval(() => {
            setFileName(fileName.slice(0, i));
            i++;
            if (i > fileName.length) {
                clearInterval(interval);
            }
        }, 100);
    }

    return (
        <div>
            <OurModal
                onClose={onClose}
                onSave={onSave}
                saveBtnDisabled={!emailsList.length || !selectedReport}
                saveBtnText={isEditSchedule ? "Update" : "Save"}
                size="medium"
                title={`${isEditSchedule ? "Edit" : "Add"} Schedule`}
            >
                <div className="modal-row">
                    <div className="single-select-label">
                        <label htmlFor="report">Select The Report</label>
                    </div>
                    <div className="single-input-field">
                        <select
                            value={selectedReport}
                            onChange={(e) => setSelectedReport(e.target.value)}
                        >
                            <option value="" key="report1">
                                --Select Report--
                            </option>
                            {reportsList.map((item) => (
                                <option key={item.key} value={item.key}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="modal-row">
                    <div className="single-select-label">
                        Schedule Start & End Date
                    </div>
                    <div className="single-input-field">
                        <div className="our-date-picker">
                            <ReportDateRange
                                mode='single'
                                monthsShown={1}
                                placeholder="Start Date (required)"
                                startDate={scheduleStartDate}
                                handleDateRange={(date) => setScheduleStartDate(date)}
                                style={{
                                    container: {
                                        width: '100%'
                                    },
                                    input: {
                                        width: '100%'
                                    }
                                }}
                            />
                            <ReportDateRange
                                key={endDateKey}
                                mode='single'
                                monthsShown={1}
                                placeholder="End Date (optional)"
                                startDate={scheduleEndDate}
                                handleDateRange={(date) => handleEndApply(date)}
                                style={{
                                    container: {
                                        width: '100%'
                                    },
                                    input: {
                                        width: '100%'
                                    }
                                }}
                            />
                        </div>
                        {endDateErrMsg && <p className="endDateErrMsg">End date before start date?  come on... select a different date</p>}
                    </div>
                </div>
                <div className="modal-row">
                    <div className="single-select-label">
                        Select Delivery Dates & Time
                    </div>
                    <div className="single-input-field">
                        <div className='frequency-select'>
                            <select
                                className='frequency-select-dropdown'
                                value={selectedFrequency}
                                onChange={(e) => setSelectedFrequency(e.target.value)}
                            >
                                {dateFrequency?.map((el) => (
                                    <option key={el} value={el}>
                                        {el}
                                    </option>
                                ))}
                            </select>

                            <select
                                className="time-select"
                                value={selectedTime}
                                onChange={(e) => setSelectedTime(e.target.value)}
                            >
                                {timeFrames?.map((el) => (
                                    <option key={el.label} value={el.value}>
                                        {el.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {quarterSelected && <p className="quarter-selected">Quarter starts from start date</p>}
                    </div>
                </div>
                {showDayOrDateSelect && (
                    <div className="modal-row">
                        <div className="single-select-label">
                            Select {selectedFrequency === "Weekly" ? "Days" : "Dates"}
                        </div>
                        <div className="single-input-field">
                            {selectedFrequency === "Weekly" && (
                                <div className="dates-select">
                                    <Select
                                        options={numberedWeekDays}
                                        value={selectedDaysOfWeek}
                                        isMulti={true}
                                        isClearable={true}
                                        isSearchable={true}
                                        onChange={(days) => setSelectedDaysOfWeek(days)}
                                        placeholder="Select Day"
                                        styles={selectStyle}
                                    />
                                </div>
                            )}

                            {selectedFrequency === "Monthly" && (
                                <div className="dates-select">
                                    <ReportDateRange
                                        mode='monthDays'
                                        selectedDates={selectedDaysOfMonth}
                                        handleDateRange={(days) => setSelectedDaysOfMonth(days)}
                                        lastDayOfMonth={onLastDayOfMonth}
                                        changeLastDayOfMonth={(checked) => setOnLastDayOfMonth(checked)}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <div className="modal-row">
                    <div className="add_email_field">
                        <div className="email_autosuggest">
                            <Autosuggest
                                suggestions={filteredSuggestions}
                                onSuggestionsFetchRequested={filterSuggestions}
                                onSuggestionsClearRequested={clearSuggestions}
                                getSuggestionValue={selectSuggestion}
                                renderSuggestion={renderSuggestion}
                                inputProps={{
                                    placeholder: "Send To: (Enter a valid Email Address)",
                                    value: newEmailAddress || "",
                                    onChange: handleEmailInput
                                }}
                            />
                            {invalidEmail && <small className="invalid_email">{invalidEmail}</small>}
                            <button
                                className="custom_add_btn"
                                disabled={!newEmailAddress?.length}
                                onClick={addEmailAddress}
                            >
                                Add
                            </button>
                        </div>
                        <div className="email_list_field">
                            <p className="email_list_title">Added Emails:</p>
                            <div className="added_emails_list">
                                {emailsList.map((el, i) => (
                                    <span className="list_email_span" key={i}>
                                        {el}
                                        <span
                                            onClick={() => removeEmailAddress(el)}
                                            className="delete_item"
                                        >
                                            X
                                        </span>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-row">
                    <div className="message-fields">
                        <div className="subject-field">
                            <label className="subject-label">Subject</label>
                            <input
                                type="text"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                            />
                        </div>
                        <div className="message-field">
                            <label className="message-label">Message</label>
                            <textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="modal-row">
                    <div className="single-select-label">
                        <label htmlFor="file-name">Enter a File Name (optional)</label>
                    </div>
                    <div className="single-input-field">
                        <div className='file_name '>
                            <input
                                className="file-name-input"
                                type="text"
                                id="file-name"
                                placeholder={`My ${selectedReport ? reportsList.find(el => el.key === selectedReport)?.label : ''} report`}
                                value={fileName}
                                onChange={(e) => setFileName(e.target.value)}
                            />
                            <img
                                width="24"
                                height="24"
                                src="https://img.icons8.com/forma-thin/24/sparkling.png"
                                alt="sparkling"
                                title="Generate a file name"
                                onClick={generateFileName}
                            />
                        </div>
                    </div>
                </div>
                <div className="modal-row">
                    <div className="single-select-label">
                        <label htmlFor="file-format">Select the File Format</label>
                    </div>
                    <div className="single-input-field">
                        <select
                            className="file-format-select"
                            value={fileFormat}
                            onChange={(e) => setFileFormat(e.target.value)}
                        >
                            <option value="pdf">PDF</option>
                            <option value="csv">CSV</option>
                        </select>

                    </div>
                </div>
            </OurModal >
        </div >
    )
}

const mapStateToProps = ({ UserReducer }) => ({
    UserReducer
})

export default connect(mapStateToProps)(AddSchedule)